function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScNavAccount = function SvgScNavAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.43597 3.18404C1 4.03969 1 5.15979 1 7.4V16.6C1 18.8402 1 19.9603 1.43597 20.816C1.81947 21.5686 2.43139 22.1805 3.18404 22.564C4.03969 23 5.15979 23 7.4 23H16.6C18.8402 23 19.9603 23 20.816 22.564C21.5686 22.1805 22.1805 21.5686 22.564 20.816C23 19.9603 23 18.8402 23 16.6V7.4C23 5.15979 23 4.03969 22.564 3.18404C22.1805 2.43139 21.5686 1.81947 20.816 1.43597C19.9603 1 18.8402 1 16.6 1H7.4C5.15979 1 4.03969 1 3.18404 1.43597C2.43139 1.81947 1.81947 2.43139 1.43597 3.18404ZM10.5 8C10.5 7.17157 11.1716 6.5 12 6.5C12.8284 6.5 13.5 7.17157 13.5 8C13.5 8.82843 12.8284 9.5 12 9.5C11.1716 9.5 10.5 8.82843 10.5 8ZM12 4.5C10.067 4.5 8.5 6.067 8.5 8C8.5 9.933 10.067 11.5 12 11.5C13.933 11.5 15.5 9.933 15.5 8C15.5 6.067 13.933 4.5 12 4.5ZM7 16C7 15.4477 7.44772 15 8 15H16C16.5523 15 17 15.4477 17 16V19H19V16C19 14.3431 17.6569 13 16 13H8C6.34315 13 5 14.3431 5 16V19H7V16Z",
    fill: "var(--on-surface)",
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 1
    }
  }));
};
export default SvgScNavAccount;